import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { PaginateProvider } from 'contexts/paginate';
import Plan from 'components/space/plan';
import BreadcrumbContainer from 'components/breadcrumb_container';
import Container from 'components/layout/container';
import Orders from 'components/space/order/index_container';
const Billing = () => {
  return (
    <Container>
      <BreadcrumbContainer>
        <BreadCrumbTypography><FormattedMessage id="breadcrumb.billing" /></BreadCrumbTypography>
      </BreadcrumbContainer>
      <Plan />
      <PaginateProvider>
        <Orders />
      </PaginateProvider>
    </Container>
  );
};

export default Billing;
